module.exports = __webpack_public_path__ + "img/3dbdb54.webp";